import { Injectable, Injector, inject } from '@angular/core';
import { TitleStrategy, RouterStateSnapshot, Route, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class CustomTitleStrategy extends TitleStrategy {
  private injector = inject(Injector);
  private titleService = inject(Title);
  private translateService = inject(TranslateService);

  private router: Router | null = null;

  private getRouter(): Router {
    if (!this.router) {
      this.router = this.injector.get(Router);
    }
    return this.router;
  }

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const titleKey = this.buildTitle(snapshot);

    if (titleKey) {
      this.setTranslatedTitle(titleKey);
      return;
    }

    // TODO: Remove following code and all related logic (functions) once all views are over refactor to new Angular
    const router = this.getRouter();
    const fallbackPath = this.extractFirstSegment(snapshot.url);

    if (fallbackPath) {
      const fallbackTitleKey = this.findTitleByPath(router.config, fallbackPath);
      if (fallbackTitleKey) {
        this.setTranslatedTitle(fallbackTitleKey);
        return;
      }
    }
    // TODO: ^^^^^^^^^^^^

    this.titleService.setTitle('Cellosign');
  }

  override buildTitle(snapshot: RouterStateSnapshot): string | undefined {
    let route = snapshot.root;
    let deepestTitle: string | undefined;

    while (route) {
      const routeTitle = route.routeConfig?.title;
      if (typeof routeTitle === 'string') {
        deepestTitle = routeTitle;
      }
      route = route.firstChild!;
    }

    return deepestTitle;
  }

  private extractFirstSegment(url: string): string | undefined {
    const first = url.split('?')[0].split('/').filter(Boolean)[0];
    return first || undefined;
  }

  private findTitleByPath(routes: Route[], pathToFind: string): string | undefined {
    for (const route of routes) {
      if (route.path === pathToFind) {
        return typeof route.title === 'string' ? route.title : route.data?.['title'];
      }
      if (route.children) {
        const childTitle = this.findTitleByPath(route.children, pathToFind);
        if (childTitle) {
          return childTitle;
        }
      }
    }
    return undefined;
  }

  private setTranslatedTitle(titleKey: string) {
    this.translateService.get(titleKey).subscribe((translated) => {
      this.titleService.setTitle(translated);
    });
  }
}
